import { render, staticRenderFns } from "./Preguntas.vue?vue&type=template&id=21c4da74&scoped=true&"
import script from "./Preguntas.vue?vue&type=script&lang=js&"
export * from "./Preguntas.vue?vue&type=script&lang=js&"
import style0 from "./Preguntas.vue?vue&type=style&index=0&id=21c4da74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c4da74",
  null
  
)

export default component.exports